import axios from 'axios';
import { intersection, isEmpty } from 'lodash';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

const fieldsUsedInProjectList = ['client', 'name', 'phase', 'phaseName'];

const useUpdateStandardizationProject = () => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(async ({ id, projectData }) => {
    const updatedProject = await axios.patch(`/standardization/${id}`, projectData);
    return updatedProject;
  });

  const updateProject = (id, formData, { onSuccess, hideNotifications = false } = {}) => {
    mutate(
      { id, projectData: { ...formData, id } },
      {
        onSuccess: (res) => {
          const fieldsToUpdate = Object.keys(formData);
          if (!isEmpty(intersection(fieldsToUpdate, fieldsUsedInProjectList))) {
            queryClient.setQueryData('standardizationProjects', (projects) => {
              const { client, name, phase, phaseName } = res.data;
              const projectToUpdate = projects?.find((p) => p.id === id);
              if (!projectToUpdate) return projects;
              projectToUpdate.client = client;
              projectToUpdate.name = name;
              projectToUpdate.phase = phase;
              projectToUpdate.phaseName = phaseName;

              return projects;
            });
          }

          queryClient.invalidateQueries(['standardizationProjects', { projectId: id }], { exact: true });
          if (!hideNotifications) {
            toast.success(`Successfully Updated! `);
          }

          onSuccess && onSuccess(res.data);
        },
        onError: (res) => {
          toast.error(res.message);
        },
      }
    );
  };

  return {
    updateProject,
    isLoading,
  };
};

export default useUpdateStandardizationProject;
